<form [formGroup]="exportForm" (ngSubmit)="onSubmit($event)">
  <h3 mat-dialog-title>Экспорт результатов</h3>
  <div mat-dialog-content>
    <div class="row">
      <mat-form-field>
        <mat-label>Период с</mat-label>
        <input matInput formControlName="fromDate" [matDatepicker]="fromDatePicker"
               autocomplete="off"
               [min]="minDate"
               [max]="exportForm.controls.toDate.value">
        <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #fromDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Период по</mat-label>
        <input matInput formControlName="toDate" [matDatepicker]="toDatePicker"
               autocomplete="off"
               [min]="exportForm.controls.fromDate.value"
               [max]="maxDate">
        <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #toDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button
            type="button"
            (click)="onCancel()">Отмена
    </button>
    <button mat-flat-button color="primary"
            type="submit"
            cdkFocusInitial
            (click)="onSubmit($event)">Экспорт
    </button>
  </div>
</form>
